import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import {
    Card,
    CardContent,
    Typography,
    IconButton,
    Button,
} from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";

export default function History() {
    const { getHistoryOfUser } = useContext(AuthContext);
    const [meetings, setMeetings] = useState([]);
    const routeTo = useNavigate();

    useEffect(() => {
        const fetchHistory = async () => {
            try {
                const history = await getHistoryOfUser();
                setMeetings(history);
            } catch (err) {
                console.error("Failed to fetch history", err);
            }
        };
        fetchHistory();
    }, []);

    const formatDateTime = (dateString) => {
        const date = new Date(dateString);

        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();

        let hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const ampm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12 || 12;

        return `${day}/${month}/${year} • ${hours}:${minutes} ${ampm}`;
    };

    return (
        <div style={{ padding: "24px", maxWidth: 800, margin: "auto" }}>
            <IconButton onClick={() => routeTo("/home")}>
                <HomeIcon />
            </IconButton>

            {meetings.length === 0 ? (
                <Typography color="text.secondary">
                    No meeting history found.
                </Typography>
            ) : (
                meetings.map((e) => (
                    <Card
                        key={e._id} // ✅ ONLY correct key
                        variant="outlined"
                        sx={{ mb: 2, borderRadius: 2 }}
                    >
                        <CardContent
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}
                        >
                            <div>
                                <Typography fontWeight={600}>
                                    Code: {e.meetingCode}
                                </Typography>
                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                >
                                    {formatDateTime(e.joinedAt)}{" "}
                                    {/* ✅ correct */}
                                </Typography>
                            </div>

                            <Button
                                variant="contained"
                                size="small"
                                onClick={() => routeTo(`/${e.meetingCode}`)}
                            >
                                Rejoin
                            </Button>
                        </CardContent>
                    </Card>
                ))
            )}
        </div>
    );
}
